<template>
  <header class="header">
    <!-- header__top -->
    <div class="header__top" :class="{ color: !fullHeader }" v-sticky>
      <b-container
        :fluid="containerFluid"
        class="d-flex justify-content-between"
      >
        <Nav v-if="isDashboard"></Nav>
        <NavHome v-else></NavHome>
      </b-container>
    </div>
    <!-- header__top -->

    <!-- header__middle -->
    <div class="header__middle" v-if="fullHeader">
      <div class="container">
        <h1 class="page-title header__page-title">Онлайн тестирование</h1>
        <p class="page-subtitle header__page-subtitle">
          Пройдите тестирование по математике
        </p>

        <div class="header__action">
          <router-link to="exam/begin" class="e-btn">Начать тест</router-link>
        </div>
      </div>
    </div>
    <!-- header__middle -->
  </header>
</template>

<script>
import Nav from '@/components/Nav';
import NavHome from '@/components/NavHome';
import Sticky from '@/directives/sticky';

export default {
  props: {
    fullHeader: Boolean,
    containerFluid: Boolean
  },
  components: {
    Nav,
    NavHome
  },
  directives: {
    Sticky
  },
  computed: {
    isHome() {
      return this.$route.name === 'Home';
    },
    isDashboard() {
      return this.$route.name === 'Dashboard';
    },
    isContainerFluid() {
      return this.fullHeader ? 'container-fluid' : 'container';
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  }
};
</script>
